/**
 * Area de transferencia, com o caminho antigo para o navegador sem a API nova.
 *
 * Usada pelo CopyButton (P-FUN-2b).
 */

/**
 * Copia para a area de transferencia pelo caminho antigo, para o navegador sem a API
 * de area de transferencia (pagina sem HTTPS, navegador antigo). Devolve se copiou.
 */
function copiarPeloCaminhoAntigo(texto: string): boolean {
  const area = document.createElement('textarea');
  area.value = texto;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  try {
    return typeof document.execCommand === 'function' && document.execCommand('copy');
  } catch {
    return false;
  } finally {
    document.body.removeChild(area);
  }
}

/** Copia o texto. Devolve se deu certo, sem lancar: quem chama so avisa a pessoa. */
export async function copiarTexto(texto: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(texto);
      return true;
    } catch {
      // A permissao pode ter sido negada; o caminho antigo ainda pode funcionar.
    }
  }
  return copiarPeloCaminhoAntigo(texto);
}
